window.translations = window.translations || {};

(function (translations) {
    'use strict';

    translations['en'] = {
        //GENERICS
        'CLOSE' : 'Close',
        'ERROR' : 'Error',
        'OK' : 'Ok',
        'REMOVE' : 'Remove',
        'CANCEL' : 'Cancel',
        'ON' : 'On',
        'YES' : 'Yes',
        'OFF' : 'Off',
        'LOADING' : 'Loading',
        'LOADING2' : 'Loading data...',
        'MORE_ELEMENTS' : 'More elements',
        'REQUIRED' : 'Required',
        'HOME' : 'Home',
        'POWERED_BY' : 'Powered by',
        'HERE' : 'here',
        'CORPORATE': 'www.upplication.com',

        //BANNER
        'FCMPLUGIN.BANNER' : 'Almost done! Synchronizing some last info',

        //ERRORS
        'NETWORK_ERROR' : 'Ups! There seems to be an error. Try again or contact your administrator.',
        'CONTACT_CREATOR' : 'If you have any doubt contact the administrator.',

        //NAV BAR
        //Langs
        'LANG' : 'Language',
        'SPANISH' : 'Spanish',
        'ENGLISH' : 'English',
        'SUAJILI' : 'Suajili',

        //PWA advise
        'PWA.ICON': 'Add to Home Screen',
        'PWA.ADD': 'To install as an App, tap the following icon in your browser bar and choose this option: ',

        //ABOUT
        'ABOUT.INFO.WHO': 'Who',
        'ABOUT.INFO.CONTACT': 'Contact',
        'ABOUT.INFO.LOCATION': 'Where',
        'ABOUT.INFO.SOCIAL_NETWORK': 'Social',
        'ABOUT.INFO.POLICY': 'Company Policy',

        // LOADERS
        'LOADER.APPLOAD.TEXT': 'Loading...',
        'LOADER.APPUPDATE.TEXT': 'App updating!',

        //LOGIN STUFF
        'LOGIN.USER' : 'User',
        'LOGIN.EMAIL' : 'Email',
        'LOGIN.NAME' : 'First name',
        'LOGIN.PHONE' : 'Phone',
        'LOGIN.SURNAME' : 'Last name',
        'LOGIN.CAPTCHA' : 'Captcha',
        'LOGIN.PASSWORD' : 'Password',
        'LOGIN.PASSWORD.CONFIRM' : 'Confirm Password',
        'LOGIN.REMEMBER' : 'Remember',
        'LOGIN.SIGNIN' : 'Sign in',
        'LOGIN.SIGNOUT' : 'Sign out',
        'LOGIN.GOTOLOGIN' : 'Go to login',
        'LOGIN.FAIL.TITLE' : 'Error',
        'LOGIN.FAIL' : 'Wrong username or password.',
        'LOGIN.FAIL.MSG' : 'Please try again or contact your administrator.',
        'LOGIN.NEEDED.TITLE' : 'Warning! Credentials needed to view this section.',
        'LOGIN.NEEDED.MSG' : 'Please, click on "Go to login" button and sign in.',
        'LOGIN.HAVE_ACCOUNT' : 'Are you not registered? Sign up clicking',
        'LOGIN.RESTORE_PASSWORD' : 'Have you forgotten your password? Restore it clicking',

        //COMMONS FOR REGISTER & ACCOUNT
        'LOGIN.ERR.VALIDATION' : 'Invalid info:',
        'LOGIN.ERR.VALIDATION.MSG' : 'Fields marked are invalid. Pls, try again.',

        //ACCOUNT
        'LOGIN.ACCOUNT' : 'My account',
        'LOGIN.ACCOUNT.HEADER' : 'Your account info',
        'LOGIN.ACCOUNT.UPDATE-ACCOUNT' : 'Update',
        'LOGIN.ACCOUNT.DELETE-ACCOUNT' : 'Remove account',
        'LOGIN.ACCOUNT.OK' : 'Your account info has been updated',
        'LOGIN.ACCOUNT.ERR.SERVER' : 'Error updating your account info.',
        'LOGIN.ACCOUNT.ERR.SERVER.MSG.DEFAULT' : 'There has been an error processing your register',

        //REGISTER
        'LOGIN.REGISTER' : 'Register',
        'LOGIN.REGISTER.HEADER' : 'Register your new account!',
        'LOGIN.REGISTER.TERMS.TEXT': 'I accept the ',
        'LOGIN.REGISTER.TERMS.LINK': 'terms and conditions',
        'LOGIN.REGISTER.CREATE-ACCOUNT' : 'Create my Account',
        'LOGIN.REGISTER.OK' : ' You are almost in!',
        'LOGIN.REGISTER.OK.MSG' : 'We will send you an email including the activation link to verify your account.',
        'LOGIN.REGISTER.ERR.SERVER' : 'Error registering.',
        'LOGIN.REGISTER.ERR.SERVER.MSG.DUPLICATED-EMAIL' : 'This email address has already been registered',
        'LOGIN.REGISTER.ERR.SERVER.MSG.DEFAULT' : 'There has been an error processing your register',
        'LOGIN.REGISTER.SUCCESS.MSG' : 'You have been successfully registered.',

        //ACTIVATE
        'LOGIN.ACTIVATE.HEADER': 'Activate your Account',
        'LOGIN.ACTIVATE.TEXT': 'You must have an Email with 4 digits code to activate your account',
        'LOGIN.REGISTER.RESEND-ACTIVATE-ACCOUNT': 'If you cant find the email, click here to resend to you',
        'LOGIN.REGISTER.ACTIVATE-ACCOUNT': '¡Activate!',
        'LOGIN.ACTIVATE.ERR.SERVER': 'Error trying to activate the user',
        'LOGIN.RESEND.ACTIVATE.ERR.SERVER': 'Error trying to send the activation email',

        //CART (module)
        'ADDRESS.NAME' : 'Street Address',
        'ADDRESS.POSTAL-CODE' : 'Postal / Zip code',
        'ADDRESS.CITY' : 'City',
        'ADDRESS.STATE' : 'State / Prov. / Region',
        'ADDRESS.COUNTRY' : 'Country',
        'ADDRESS.CIF' : 'CIF',
        'ADDRESS.PHONE' : 'Telephone',
        'ADDRESS.PERSON' : 'I am a particular',
        'ADDRESS.BUSINESS' : 'I am a business',
        'ADDRESS.VAT' : 'VAT ID',
        'ADDRESS.DNI' : 'DNI',
        'ADDRESS.NIF' : 'NIF',
        'ADDRESS.ADDRESSEE' : 'Addressee',
        'ADDRESS.BUSINESS_NAME' : 'Business name',

        //CATALOG (module)
        'CATALOG.PRODUCTS.SHOW.BTN.BLOCK' : 'Show on block',
        'CATALOG.PRODUCTS.SHOW.BTN.INLINE' : 'Show inline',

        // ORDERS
        'MY-ORDERS.MENU' : 'My orders',
        'MY-ORDERS.TITLE' : 'My orders',
        'MY-ORDERS.DATE' : 'Date',
        'MY-ORDERS.PRICE' : 'Price',
        'MY-ORDERS.SENT' : 'Sent',

        'MY-ORDERS.SHIPPING' : 'Shipping Address',

        'MY-ORDERS.BILLING' : 'Billing Address',
        'MY-ORDERS.OBSERVATIONS' : 'Observations',

        'MY-ORDERS.AMOUNT' : 'Amount',
        'MY-ORDERS.PRODUCT' : 'Product',
        'MY-ORDERS.SIZE' : 'Size',
        'MY-ORDERS.COLOR' : 'Color',
        'MY-ORDERS.UNIT-PRICE' : 'Price',
        'MY-ORDERS.TOTAL-PRICE' : 'Total',
        'MY-ORDERS.SHIPPING-CHARGES' : 'Shipping Charges',
        'MY-ORDERS.PAYMENT_METHOD' : 'Payment method',
        'MY-ORDERS.PAID_WITH_PAYPAL' : 'Paid with PayPal',
        'MY-ORDERS.PAID_WITH_REDSYS' : 'Paid with Credit Card',
        'MY-ORDERS.PAY_ON_DELIVERY' : 'Payment on delivery',
        'MY-ORDERS.PAY_WIRE_TRANSFER': 'Wire transfer pay',
        'MY-ORDERS.PAY_AT_STORE': 'Payment in store',
        'MY-ORDERS.NO-ORDER' : 'There are no orders',

        // RESTORE
        'RESTORE.TITLE' : 'Restore password',
        'RESTORE.FAIL.MSG' : 'An user with the given email could not be found. Try it again.',
        'RESTORE.FAIL' : 'Error',
        'RESTORE.EMAIL' : 'Enter your email',
        'RESTORE.EMAIL.SAMPLE': 'E.g.: john@gmail.com',
        'RESTORE.SUBMIT' : 'Restore',
        'RESTORE.SUCCESS.MSG' : 'An email has been sent to your account so you can restore your password.',

        // CHANGE PASSWORD
        'CHANGE_PASSWORD.BTN': 'Change password',
        'CHANGE_PASSWORD.TITLE' : 'New password',
        'CHANGE_PASSWORD.FAIL.MSG' : 'There has been an error and we could not change your password.',
        'CHANGE_PASSWORD.FAIL' : 'Error',
        'CHANGE_PASSWORD.PASSWORD' : 'Password',
        'CHANGE_PASSWORD.PASSWORD_REPEAT' : 'Repeat password',
        'CHANGE_PASSWORD.SUBMIT' : 'Change password',
        'CHANGE_PASSWORD.SUCCESS.MSG' : 'Password has been changed successfully.',

        //HTTP ERRORS CODES
        'HTTP.ERROR.childupp.not-exists': 'The website is unavailable.',
        'HTTP.ERROR.childupp.out-of-service': 'The website is unavailable.',
        'HTTP.ERROR.childupp.trial.expired': 'The website is temporarily unavailable.',
        'HTTP.ERROR.payment.blocked': 'The website is temporarily unavailable.',
        'HTTP.ERROR.user.email.in-use': 'Indicated email address has already been registered.',
        'HTTP.ERROR.user.code.not-valid': 'The activation code is invalid',
        'HTTP.ERROR.user.not-exists': 'The user not exists',
        // FIXME: translate or remove (maybe not have sense to send this info from the server side)
        'HTTP.ERROR.user.childupp.not-match': 'translate!!',
        'HTTP.ERROR.product.not-found': 'translate!!',
        'HTTP.ERROR.empty.basket': 'translate!!',
        'HTTP.ERROR.shippingcharges.not-found': 'translate!!',
        'HTTP.ERROR.user.data.incomplete': 'translate!!',
        'HTTP.ERROR.user.status.waiting': 'translate!!',
        'HTTP.ERROR.payment.data.not-found': 'translate!!',
        'HTTP.ERROR.order.not-exists': 'translate!!',
        'HTTP.ERROR.order.childupp.not-match': 'translate!!',
        'HTTP.ERROR.order.not-waiting': 'translate!!',
        'HTTP.ERROR.catalog.contact-info.not-found': 'translate!!',
        'HTTP.ERROR.catalog.promotion.not-found': 'translate!!',
        'HTTP.ERROR.catalog.category.not-found': 'translate!!',

        'HTTP.ERROR.DEFAULT' : 'There has been an error processing your request. Please try again or contact your administrator.'
    };

})(window.translations);



// WEBPACK FOOTER //
// ./src/app/common/lang/lang_en.js